import { PDFDownloadLink } from "@react-pdf/renderer";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { useSortableData } from "../../app/hooks/useSortableData";
import moment from "moment";
import { schemaValidateMenusList } from "../../app/data/schemaValidateMenusList";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import ExportToExcelMenus from "./ExportToExcelMenus";
import ExportToPdfMenusDesign from "./ExportToPdfMenusDesign";

const ID_FORM = "admin-menu";
const OPERATION_EDIT = "edit";
const OPERATION_DELETE = "delete";

const TableMenus = ({ data, onEditRow, onDeleteRow }) => {
  
  const { items, requestSort, sortConfig } = useSortableData(data);
  const { t } = useTranslation();

  const { listSeries, listSizes } = useSelector((state) => state.catalog);

  const { menusFull } = useSelector((state) => state.menu);

  const { catalogModules } = useSelector((state) => state.catalogModule);

  const { catalogRoles } = useSelector((state) => state.catalogRole);

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const getStyleSortI = (accessor, sortConfig) => {
    let styleSort;
    if (accessor === sortConfig?.key && sortConfig.direction === "ascending") {
      styleSort = "fa fa-fw fa-sort-down table-icon-color-sort";
    } else if (accessor === sortConfig?.key && sortConfig.direction === "descending") {
      styleSort = "fa fa-fw fa-sort-up table-icon-color-sort";
    } else {
      styleSort = "fa fa-fw fa-sort table-icon-color-sort-no";
    }
    return styleSort;
  };

  const ItemHeader = (itemIn) => {
    const { item } = itemIn;
    
    if (item.show_in_table) {
      return (
        <th scope="col" className={`${getClassNamesFor(item.field)} th-table-cell-list`} key={item.id}>
          <button onClick={() => requestSort(item.field)} className={`${getClassNamesFor(item.field)} th-table-button`}>
            {t(`${item.module_text}.short.${item.field}`)}
            <i className={getStyleSortI(item.field, sortConfig)}></i>
          </button>
        </th>
      )
    }
  }

  const getObjectById = (id, arraySearch) => {

    const elementFound = arraySearch && arraySearch.find((ser) => ser.id === id);
    
    return elementFound;
  };

  const ItemRow = (itemIn) => {
    const { item } = itemIn;
    
    return (
      <Fragment>
        {schemaValidateMenusList && schemaValidateMenusList.length > 0 && (
          schemaValidateMenusList.map((tech, index) => {

            if (tech.show_in_table && tech.data_type === 'id') {
              
              return (
                <th scope="row" className={`${tech.style_in_table}`} key={item.id}>{item.id}</th>
              )
            }
            else if (tech.is_in_bdd && tech.show_in_table && tech.data_type === 'integer') {
             
              const columnTo = tech.field;
             
              const textField = item[`${columnTo}`];

              let textShow = "";
              
              if (tech.field === 'catalogserie_id') {
                
                const objectShow = getObjectById(textField, listSeries);
                textShow = objectShow && objectShow.name;
                
              } else if (tech.field === 'catalogsize_id') {
                
                const objectShow = getObjectById(textField, listSizes);
                textShow = objectShow && objectShow.name;

              }else if (tech.field === 'parent_id') {
                
                const objectShow = getObjectById(textField, menusFull);
                
                textShow = objectShow && objectShow.title;

              }else if (tech.field === 'catalogrole_id') {
                
                const objectShow = getObjectById(textField, catalogRoles);
                
                textShow = objectShow && objectShow.name;

              }else if (tech.field === 'catalogmodule_id') {
                
                const objectShow = getObjectById(textField, catalogModules);
                
                textShow = objectShow && objectShow.name;

              }

              return (
                <td className={tech.style_in_table}>
                  {textShow}
                </td>
              )
            }else if (tech.is_in_bdd && tech.show_in_table && tech.data_type === 'number') {
              let textShow = "";
              if(tech.field === 'level') {
                const columnTo = tech.field;
                const textField = item[`${columnTo}`];
                textShow = textField;
              }else if(tech.field === 'order') {
                const columnTo = tech.field;
                const textField = item[`${columnTo}`];
                textShow = textField;
              }

              return (
                <td className={tech.style_in_table}>
                  {textShow}
                </td>
              )
            }
            else if (tech.show_in_table && tech.data_type === 'string') {
              const columnTo = tech.field;
              const textField = item[`${columnTo}`];

              return (
                <td className={tech.style_in_table}>
                  <ReadMoreReadLess
                    className={`${tech.style_in_table} read-more-less`}
                    buttonClassName='btn-read-more-less'
                    expandLabel="Leer más" 
                    collapseLabel="Leer menos" 
                    limit={tech.readmore_limit_table}
                  
                  >
                    {textField}
                  </ReadMoreReadLess>
                </td>
              )
            } else if (tech.show_in_table && tech.data_type === 'datetime') {
              const columnTo = tech.field;
              const textField = item[`${columnTo}`];
              return (

                <td>{moment(textField).local().format("DD-MM-YYYY")}</td>
              )
            } else if (tech.show_in_table && tech.data_type === 'buttons') {
              return (
                <td className={tech.style_in_table} >
                  <div>
                    <button data-tip data-for="editTechnologyTip" className="table-button-edit" onClick={() => onEditRow(item)}>
                      {" "}
                      <i className="fa fa-edit"></i>
                    </button>
                    <ReactTooltip id="editTechnologyTip" place="left" effect="solid">
                       {t(`${ID_FORM}.page.${OPERATION_EDIT}`)}
                    </ReactTooltip>
                    <button data-tip data-for="deleteTechnologyTip" className="table-button-delete" onClick={() => onDeleteRow(item)}>
                      <i className="fa fa-trash"></i>
                    </button>{" "}
                    <ReactTooltip id="deleteTechnologyTip" place="left" effect="solid">
                       {t(`${ID_FORM}.page.${OPERATION_DELETE}`)}
                    </ReactTooltip>
                  </div>
                </td>
              )
            }
          })
        )}
      </Fragment>
    )
  }

  const tab = "\u00A0";

  return (
    <div style={{ paddingRight: "25px", paddingLeft: "25px" }}>
      <div className="table-responsive">
        <table className="table table-bordered">
          {false && (
            <caption className="caption-down">
              <div className="d-flex justify-content-center">
                {t("label.export_to")}: {tab}
                {data && data.length > 0 && (
                  <ExportToExcelMenus

                    data={items}
                  />
                )}
                {data && data.length > 0 && (
                  <PDFDownloadLink document={<ExportToPdfMenusDesign data={items} />} fileName="user_data.pdf">
                    {({ blob, url, loading, error }) => (loading ? "Loading document..." : <i className="fa fa-file-pdf fa-1x" aria-hidden="true" />)}
                  </PDFDownloadLink>
                )}
              </div>
            </caption>
          )}

          <thead className="">
            {/* Start Table Header Columns */}
            <tr>
              {schemaValidateMenusList && schemaValidateMenusList.length > 0 && (
                schemaValidateMenusList.map((item, index) => {
                  return (
                    <ItemHeader
                      key={item.id}
                      item={item} />
                  )
                })
              )}
            </tr>
            {/* Start Table Header Columns */}
          </thead>

          <tbody>
            {/* Start Table Body Columns */}
            {data && data.length > 0 && (
              items.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <ItemRow
                      item={item} />
                  </tr>
                )
              })
            )}
            {/* End Table Body Columns */}
          </tbody>
        </table>
      </div>
    </div >
  );
};

export default TableMenus;